import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Formik, Form } from 'formik';
import { Link, useHistory } from 'react-router-dom';

import { Container, FormActions } from './styles'

import Text from '../../components/Text'
import ButtonBack from '../../components/ButtonBack'
import Input from '../../components/Form/Input';
import { FormGroup, Label } from '../../components/Form'

import Spacing from '../../components/Spacing'
import Button from '../../components/Button';

import { login, logout } from '../../services/user';
import ErrorBox from '../../components/ErrorBox';
import Loading from '../../components/Loading';
import m from '../../utils/messages';

export const LoginForm = () => {
  const history = useHistory();

  const credentials = useSelector(state => state.main.credentials);

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!credentials) {
      history.replace('/login');
    }
  }, [credentials, history]);

  const handleSubmit = async (formData, { setSubmitting }) => {
    setSubmitting(true);
    setError(null);
    try {
      await logout();
    } catch {}
    try {      
      const data = await login({ 
        [credentials.field]: credentials.value, 
        password: formData.password, 
        document: credentials?.document || undefined
      });
      setSuccess(true);
      window.location.href = data.redirectTo;
    } catch (err) {
      switch(err.code) {
        case "resetPassword": 
          sessionStorage.setItem('@resetToken@', err.token);
          return history.push('/password/reset');
        case "createPassword":
          return history.push('/password/code');
        case "unauthorized":
          return setError('Usuário e/ou senha estão incorretos, verifique a senha ou clique em esqueci a minha senha.');
        default:
          return setError(m('internalError'));
      }
    }

    setSubmitting(false);
  }

  return (
    <>
      <ButtonBack onClick={() => history.goBack()} />
      <Container>
        {success && <Loading position="fixed" />}
        <Text variant="title2" weight={600} align="center">
          Use uma das opções para se logar
        </Text>
        <Spacing size={24} />
        <Formik initialValues={{ login: credentials?.publicValue, password: '' }} onSubmit={handleSubmit}>
          {({ isSubmitting }) => (
            <Form className="login__form form">
              <ErrorBox error={error}/>
              <FormGroup>
                <Label>Login</Label>
                <Input name="login" autoComplete="off" disabled />
              </FormGroup>
              <Spacing size={24} />
              <FormGroup>
                <Label>Senha</Label>
                <Input type="password" name="password" autoComplete="off" />
              </FormGroup>
              <FormActions>
                <Link to="/password/forgot" className="login__forgot">Esqueci minha senha</Link>
                <Button text="Enviar" variant="buttonPrimary" loading={isSubmitting} />
              </FormActions>
            </Form>
          )}
        </Formik>
      </Container>
    </>
  )
}
